import { ActionKey, ItemMenuProps } from '../Types'
import { useRemovable } from './hooks/useRemovable'
import { useItemContextMenu } from './hooks/useItemContextMenu'
import { handbookFullUrl } from 'components/Handbook2_0/util'
import { useLinkable } from './hooks/useLinkable'
import { useCopyable } from './hooks/useCopyable'
import { useHandbookItems } from 'components/Handbook2_0/Sidebar/HandbookItemProvider'
import { BaseMenu } from '../BaseMenu'
import { useShareable } from './hooks/useShareable'
import { useFavoritable } from './hooks/useFavoritable'

export const MentionItemMenu = ({ item, ...props }: ItemMenuProps) => {
  const { currentHandbook: handbook } = useHandbookItems()
  const { shareable, handleShareable } = useShareable(item)
  const { favoritable, handleFavorite } = useFavoritable(item)
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { linkable, handleLinkable } = useLinkable(handbookFullUrl(handbook!, item.document?.seo_string), {
    copyLink: 'Copy link',
  })
  const { copyable, handleCopy } = useCopyable(item, 'Make a copy')
  const { removable, handleRemove } = useRemovable(item, 'Remove doc')

  const { visible, setVisible, handleAction } = useItemContextMenu({
    handlers: [handleRemove, handleLinkable, handleCopy, handleShareable, handleFavorite],
  })

  const disabledKeys = new Set<ActionKey>()
  if (handbook?.current_user_access && ['read', 'comment'].includes(handbook.current_user_access)) {
    disabledKeys.add(ActionKey.delete)
    disabledKeys.add(ActionKey.edit)
    disabledKeys.add(ActionKey.move)
  }

  const menus = [[linkable.newTab], favoritable, [...shareable, linkable.copyLink, ...copyable, ...removable]]

  return (
    <>
      <BaseMenu
        menus={menus}
        handleAction={handleAction}
        visible={visible}
        setVisible={setVisible}
        disabledKeys={disabledKeys}
        item={item}
        {...props}
      />
    </>
  )
}
